<template>
    <div>
        <Nav/>
        <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
        <v-stepper v-model="e1" class="mx-3 mt-3">
            <v-stepper-header>
            <v-stepper-step
                :complete="e1 > 1"
                step="1"
                editable
            >
                Our History, Mission, & Services
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="e1 > 2"
                step="2"
                editable
            >
                Redhead Supports Culture
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 3"
                step="3"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 4"
                step="4"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 5"
                step="5"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 6"
                step="6"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 7"
                step="7"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step 
                :complete="e1 > 8"
                step="8"
                editable
            >
                DHS/DSPD Rules, Philosophy, Mission, & Beliefs
            </v-stepper-step>

            </v-stepper-header>

            <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                class="mb-12 pa-3"
                color="blue-grey lighten-5"
                height="auto"
                >
                    <v-col cols="12">
                        <h3 class="font-weight-regular">Fill in the blank.  "We, the people of Redhead Supports, 
                            humbly desire to make a ____________ and indelible dent in the universe. We intend to accomplish this grandiose 
                            and ambitious _____________ by using the vehicles of love and service to others. 
                            We will make all company decisions based on a Christian concern for all men. 
                            We desire to ____________ and enrich the lives of each and every soul whose path we cross: ourselves, our families, 
                            our employees, our clients, and all other affiliated parties. We believe it is a privilege and a 
                            gift from Heavenly Father to live now, in tremendous and terrible times, in this great God-given country, and we intend to utilize 
                            this privilege to better all mankind and wear out our mortalities in the vineyard of ____________."</h3>
                        <v-radio-group>
                            <div class="red--text" id="incorrect1">Incorrect</div>
                            <v-radio label="decent; business; change; time" name="group1" ></v-radio>
                            <v-radio label="positive; endeavor; improve; service" name="group1" value="correct"></v-radio>
                            <v-radio label="fatuous; gig; ignore; the space-time continuum" name="group1" ></v-radio>
                            <v-radio label="great; group home; sparkle; grapes" name="group1"></v-radio>
                        </v-radio-group>
                        
                        <v-tooltip right v-if="help">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                Help</v-btn>
                            </template>
                            <span >
                                Redhead Supports is Positive in everything we do
                            </span>
                        </v-tooltip>
                    </v-col>

                    <v-col cols="4" class="mt-10">
                        <h3 class="font-weight-regular">What is the Redhead Supports Mantra?</h3>
                            <v-text-field label="Enter Text Here"></v-text-field>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">Which of the following services does Redhead Support provide?</h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect2">Incorrect</div>
                                <v-radio label="Residential" name="group2"></v-radio>
                                <v-radio label="Supported Living" name="group2"></v-radio>
                                <v-radio label="Supported Employment" name="group2" ></v-radio>
                                <v-radio label="Day Supports" name="group2"></v-radio>
                                <v-radio label="Host Home/Professional Parent" name="group2"></v-radio>
                                <v-radio label="All of the above" name="group2" value="correct"></v-radio>
                            </v-radio-group>
                            
                            <v-tooltip right v-if="help">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                Help</v-btn>
                            </template>
                            <span >
                                We do it all
                            </span>
                        </v-tooltip>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">In what year was Redhead Supports started?</h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect3">Incorrect</div>
                                <v-radio label="2016" name="group3"></v-radio>
                                <v-radio label="2017" name="group3" value="correct"></v-radio>
                                <v-radio label="2004" name="group3"></v-radio>
                                <v-radio label="2011" name="group3"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">True or False. Clients who recieve residential service typically live at home with their parent(s) or guardian</h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect4">Incorrect</div>
                                <v-radio label="True" name="group4"></v-radio>
                                <v-radio label="False" name="group4" value="correct"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">Which of the following Redhead Supports services are provided by a Registered Nurse? </h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect5">Incorrect</div>

                                <v-radio label="Behavior Consultant Level 3" name="group5"></v-radio>
                                <v-radio label="Professional Medication Monitoring" name="group5" value="correct"></v-radio>
                                <v-radio label="Space Survelliance" name="group5"></v-radio>
                                <v-radio label="None of the above" name="group5"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">Which of the following Redhead Supports services are considered "non-residential" services.  </h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect6">Incorrect</div>

                                <v-radio label="Personal Budget Assistance, Motor Transportation Payment, Extended Living Supports" name="group6"></v-radio>
                                <v-radio label="Behavior Consultation, Professional Medication Monitoring, Respite Supports" name="group6"></v-radio>
                                <v-radio label="Respite Supports, Host Home/Professional Parent, Personal Budget Assistance" name="group6"></v-radio>
                                <v-radio label="Supported Living, Supported Employment, Day Supports" name="group6" value="correct"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">Fill in the blank. Residential services offer habilitation, _____________________, and assistance as an alternative to placement in an institutional setting. </h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect7">Incorrect</div>

                                <v-radio label="Rewards" name="group7"></v-radio>
                                <v-radio label="Behavior Consultation" name="group7"></v-radio>
                                <v-radio label="Supervision" name="group7" value="correct"></v-radio>
                                <v-radio label="Money" name="group7"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-col cols="12" class="mt-10">
                        <h3 class="font-weight-regular">Which of the following best describes Applied Behavioral Analysis (ABA)? </h3>
                            <v-radio-group>
                                <div class="red--text" id="incorrect8">Incorrect</div>

                                <v-radio label="Supervision and management of financial matters and budget tracking for individuals receiving services" name="group8"></v-radio>
                                <v-radio label="An evidence-based practice that focuses on the analysis, design, implementation, and evaluation of social and other environmental modifications to produce meaningful changes in behavior" name="group8" value="correct"></v-radio>
                                <v-radio label="Short-term relief given to families with a child with disabilities and involves the individual residing in a host home or group home on a short-term basis" name="group8"></v-radio>
                                <v-radio label="An evidence-based practice that focuses primarily on the statistical analysis of behavioral issues that occur in the educational setting" name="group8"></v-radio>
                            </v-radio-group>
                    </v-col>

                    <v-btn 
                        @click="testTotal()"
                    >
                    
                    Submit
                    
                    </v-btn>

                    <v-btn
                        @click="sheet = !sheet"
                        v-if="review"
                    >
                        Review Section
                    </v-btn>
                    <v-bottom-sheet v-model="sheet">
                        <v-sheet
                            class="text-center"
                            height="400px"
                        >
                            <v-btn
                                class="mt-6"
                                text
                                color="red"
                                @click="sheet = !sheet"
                            >Close</v-btn>
                            <div>
                               <iframe width="560" height="315" src="https://www.youtube.com/embed/SnRA2qn2qDI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

                            </div>

                        </v-sheet>
                    </v-bottom-sheet>
                </v-card>

                <v-btn
                color="primary"
                @click="e1 = 2"
                >
                Continue
                </v-btn>

                
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 3"
                >
                Continue
                </v-btn>

                
            </v-stepper-content>

            <v-stepper-content step="3">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 4"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="4">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 5"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="5">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 6"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="6">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 7"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="7">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 8"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="8">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 9"
                >
                Continue
                </v-btn>

            </v-stepper-content>

            <v-stepper-content step="9">
                <v-card
                class="mb-12"
                color="blue-grey lighten-5"
                height="auto"
                ></v-card>

                <v-btn
                color="primary"
                @click="e1 = 1"
                >
                Continue
                </v-btn>

            </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </div>
</template>
<script>
import Nav from '@/components/Navbar.vue'
export default {
    components: { Nav },
    data: () => ({
        e1: 1,
        msg: false,
        answer: "",
        sheet: false,
        points: 0,
        total: 10,
        review: false,
        help: false,
        


    }),
    methods: {
        checkAnswer: function() {
            if(this.TrueAnswer){
                this.points += 1;
            }
        },

        testTotal: function() {
            this.points = 0;
            for(var i = 1; i <= 8; i++){
                var questions = document.getElementsByName('group'+i);
                var incorrect = document.getElementById('incorrect'+i);
                for (var j = 0; j < questions.length; j++){
                    var radio = questions[j];
                    if (radio.value == "correct" && radio.checked){
                        this.points += 1
                        
                 } else if (radio.value != "correct" && radio.checked){
                        incorrect.style.display = "block"
                 }
                    
                }
            }
            if (this.points <= 5){
                this.review = true;
                this.help = true;
            }
            alert("Correct Responses: " + this.points)
        }
    },
}
</script>
<style>
#incorrect1 {
    display: none;
}
#incorrect2 {
    display: none;
}
#incorrect3 {
    display: none;
}
#incorrect4 {
    display: none;
}
#incorrect5 {
    display: none;
}
#incorrect6 {
    display: none;
}
#incorrect7 {
    display: none;
}
#incorrect8 {
    display: none;
}
</style>